import React, { ReactNode } from 'react'
import useCustomisation from 'src/hooks/useCustomisation'
import useGetProductImagePath from '@/hooks/useGetProductImagePath'
import Image from 'next/image'

interface OptionThumbnailProps {
  variant: {
    imageFullUrls: string[]
    imageUrls: string[]
    variantName: string
  }
}

const OptionThumbnail = ({ variant }: OptionThumbnailProps): ReactNode => {
  const { getSectionFromId } = useCustomisation()
  const { settings = {} } = getSectionFromId('productDetail') || {}

  const { getProductImagePath } = useGetProductImagePath()

  const { showOptionImage, showDefaultImage } = settings

  const optionImage = getProductImagePath(
    variant.imageFullUrls?.[0] || variant.imageUrls?.[0],
    showDefaultImage as boolean,
    {
      shouldCache: true,
      containerWidth: 80,
      containerHeight: 80,
    }
  )
  return showOptionImage && optionImage ? (
    <Image
      className="mr-2.5 rounded-lg object-cover lg:mr-5"
      width={70}
      height={70}
      alt={variant.variantName}
      src={optionImage}
    />
  ) : null
}

export default OptionThumbnail
